export default "__VITE_ASSET__50750165__"